export default __webpack_public_path__ + "static/media/infoError.081593b4.svg";